import React from "react";
import { Link } from "react-router-dom";
import { FaInstagram, FaTelegramPlane, FaWhatsapp } from "react-icons/fa";
import { BiMessageSquareDetail } from "react-icons/bi";
import "./footer.scss";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="footer-section footer-info">
          <div className="footer-logo">Na_Sokah_Uz</div>
          <p>
            Мы помогаем вам становиться лучше каждый день. Программы, которые
            вдохновляют, обучают и мотивируют.
          </p>
        </div>

        <div className="footer-section footer-nav">
          <h4>Навигация</h4>
          <ul>
            <li><Link to="/advantages">Преимущества</Link></li>
            <li><Link to="/programs">Программы</Link></li>
            <li><Link to="/contacts">Контакты</Link></li>
            <li><Link to="/about">О нас</Link></li>
          </ul>
        </div>

        <div className="footer-section footer-contacts">
          <h4>Связаться с нами</h4>
          <p>Email: info@nasokah.uz</p>
          <p>Телефон: +998 93 393 80 00</p>
          <div className="socials">
            <a
              href="https://www.instagram.com/na_sokah_uz?igsh=NWE1aG4wMHl4MW1l"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>
            <a
              href="https://t.me/nasokahuz"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaTelegramPlane />
            </a>
            <a
              href="https://wa.me/998933938000"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <small className="copyright">
          © {new Date().getFullYear()} <strong>Na_Sokah</strong>
          <span className="dot">•</span>
          Все права защищены
          <span className="dot">•</span>
          Сделано c ❤️ <span className="heart" aria-hidden="true" /> by
          @zamira_dev
        </small>
      </div>
    </footer>
  );
};

export default Footer;
